<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [disabled]="!mapForm.form.valid || !formValid"
            [title]="'Edit Peer Connection'">

  <form #mapForm="ngForm" autocomplete="off" class="main-container">
    <div class="form-row">
      <mat-form-field class="fullWidth">
        <mat-label>Name</mat-label>
        <input matInput required [(ngModel)]="data.selectedItem.name" name="name">
      </mat-form-field>
    </div>

    <div class="form-row">
      <div class="form-column">
        <mat-form-field class="fullWidth">
          <mat-label>Type</mat-label>
          <input disabled matInput [(ngModel)]="data.selectedItem.peerConnectionNodeType" name="peerConnectionNodeType">
        </mat-form-field>
      </div>

      <div class="form-column">
        <mat-form-field class="fullWidth">
          <mat-label>Weight</mat-label>
          <input matInput [(ngModel)]="data.selectedItem.weight" type="number" min="1"
                 max="100" name="weight" required>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-column">
        <mat-form-field class="fullWidth">
          <mat-label>Node</mat-label>
          <input disabled matInput [(ngModel)]="data.selectedItem.nodeName" name="armNodeName">
        </mat-form-field>
      </div>
      <div class="form-column-arrow">
        <img class="arrow" src="assets/images/general/leftToRightArrow.png">
      </div>
      <div class="form-column">

        <ac-input-container label="Voip Peer"   [required]="true" >
          <ac-select
            [(acModel)]="data.selectedItem.voipPeerId"
            [items]="data.voipPeers"
            [multiple]="false"
            [allowClear]="true"
            [bindValue]="'value'"
            [bindLabel]="'text'" (acModelChange)="checkFormValid()" >
          </ac-select>
        </ac-input-container>

      </div>
    </div>

    <mat-form-field *ngIf="data.selectedItem.topologyGroups && data.selectedItem.topologyGroups.length > 0" class="fullWidth">
      <mat-label>Resource Groups</mat-label>
      <div class="resource-groups-names">
        <mat-chip-list aria-label="Resource Groups" disabled>
          <mat-chip *ngFor="let group of data.selectedItem.topologyGroups"
                    [selectable]="false" class="resource-groups-names-chip" title="{{group.name}}">
            {{group.name}}
          </mat-chip>
        </mat-chip-list>
      </div>
    </mat-form-field>

    <divider title="Normalization Before Routing"></divider>


    <div class="form-row">
      <div class="form-column">
        <ac-input-container label="Source URI User"    >
          <ac-select
            [(acModel)]="data.selectedItem.srcNormalizationGroupId"
            [items]="data.attrManipulation"
            [multiple]="false"
            [allowClear]="true"
            [bindValue]="'value'"
            [bindLabel]="'text'">
          </ac-select>
        </ac-input-container>
      </div>


      <div class="form-column">
        <ac-input-container label="Destination URI User"    >
          <ac-select
            [(acModel)]="data.selectedItem.destNormalizationGroupId"
            [items]="data.attrManipulation"
            [multiple]="false"
            [allowClear]="true"
            [bindValue]="'value'"
            [bindLabel]="'text'">
          </ac-select>
        </ac-input-container>
      </div>
    </div>


    <divider title="Advance Conditions"></divider>

    <div class="form-row">
      <div class="form-column">
        <ac-input-container label="Calls quota"    >
          <ac-select
            [(acModel)]="data.selectedItem.callsQuotaId"
            [items]="data.callsQuotas"
            [multiple]="false"
            [allowClear]="true"
            [bindValue]="'value'"
            [bindLabel]="'text'">
          </ac-select>
        </ac-input-container>

      </div>

      <div class="form-column">
        <ac-input-container label="CAC Profile"    >
          <ac-select
            [(acModel)]="data.selectedItem.cacProfileId"
            [items]="data.cacProfiles"
            [multiple]="false"
            [allowClear]="true"
            [bindValue]="'value'"
            [bindLabel]="'text'">
          </ac-select>
        </ac-input-container>
      </div>
    </div>


    <div class="form-row">
      <div class="form-column">
        <ac-input-container class="fullWidth" label="Short Calls Profile">
          <ac-select
            [(acModel)]="data.selectedItem.shortCallsProfileId"
            [items]="data.shortCallsProfilesOptions"
            [multiple]="false"
            [allowClear]="true"
            [bindValue]="'value'"
            [bindLabel]="'text'">
          </ac-select>
        </ac-input-container>
      </div>

      <div class="form-column">
        <ac-input-container class="fullWidth" label="Alternative SIP reason group">
          <ac-select
            [(acModel)]="data.selectedItem.sipReasonGroupId"
            [items]="data.sipReasonGroups"
            [multiple]="false"
            [allowClear]="true"
            [bindValue]="'value'"
            [bindLabel]="'text'">
          </ac-select>
        </ac-input-container>
      </div>
    </div>


    <div id="peer-connection-advanced-conditions-container" *ngIf="advancedConditions.isQualityEnabled">
      <mat-radio-group [(ngModel)]="useGlobalAdvancedCondition" [ngModelOptions]="{standalone: true}">
        <div class="form-row">
          <div class="form-column">
            <mat-radio-button color="primary" value="global">use global quality definitions</mat-radio-button>
          </div>
          <div class="form-column">
            <mat-radio-button color="primary" value="specific">use specific quality definitions</mat-radio-button>
            <div class="quality">
              <mat-checkbox [disabled]="useGlobalAdvancedCondition === 'global'" name="mos" color="primary"
                            [(ngModel)]="data.selectedItem.quality.MOS.isUsed">MOS</mat-checkbox>
              <mat-checkbox [disabled]="useGlobalAdvancedCondition === 'global'" name="asr" color="primary"
                            [(ngModel)]="data.selectedItem.quality.ASR.isUsed">ASR</mat-checkbox>
            </div>
          </div>
        </div>
      </mat-radio-group>
    </div>

    <divider title="SecureLogix Parameters"></divider>

    <div class="form-row">
      <div class="form-column">
        <mat-form-field class="fullWidth">
          <mat-label>Customer Id</mat-label>
          <input matInput [(ngModel)]="data.selectedItem.customerId" name="secure_logix_customer_id">
        </mat-form-field>
      </div>

      <div class="form-column">
        <mat-form-field class="mat-form-field-width">
          <mat-label >Call Direction</mat-label>
        <mat-select [(ngModel)]="data.selectedItem.callDirection " name="secure_logix_call_direction" class="fullWidth">
          <mat-option *ngFor="let item of callDirectionOptions" [value]="item.key">
            {{item.label}}
          </mat-option>
        </mat-select>
        </mat-form-field>

      </div>
    </div>
  </form>
</arm-dialog>
